var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoopSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7.5C10.5 9.433 8.933 11 7 11C5.067 11 3.5 9.433 3.5 7.5C3.5 5.567 5.067 4 7 4C8.933 4 10.5 5.567 10.5 7.5ZM9.45294 11.858C8.72824 12.2668 7.89136 12.5 7 12.5C4.23858 12.5 2 10.2614 2 7.5C2 4.73858 4.23858 2.5 7 2.5C9.76142 2.5 12 4.73858 12 7.5C12 8.39135 11.7668 9.22823 11.358 9.95292C11.6469 10.0014 11.9261 10.1272 12.1628 10.3314L14.2638 12.1435C15.0815 12.8488 15.1276 14.1004 14.364 14.864C13.6004 15.6276 12.3489 15.5815 11.6435 14.7637L9.8314 12.6629C9.62717 12.4261 9.50142 12.1469 9.45294 11.858ZM11.1831 11.4672L13.2841 13.2793C13.4416 13.4152 13.4504 13.6562 13.3034 13.8033C13.1563 13.9504 12.9152 13.9415 12.7794 13.784L10.9672 11.6831C10.9149 11.6224 10.9182 11.5316 10.9749 11.4749C11.0316 11.4182 11.1224 11.4149 11.1831 11.4672Z",
    fill: "#54687D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopSearchIcon);
export default __webpack_public_path__ + "static/media/loop-search-icon.c38683a9c74b922477b5d11a6bd6d712.svg";
export { ForwardRef as ReactComponent };